import { render, staticRenderFns } from "./TeachersToolbar.vue?vue&type=template&id=522395d7&"
import script from "./TeachersToolbar.vue?vue&type=script&lang=js&"
export * from "./TeachersToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports